import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0f53460"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Подтвердить ")

import { PropType, ref } from 'vue'
import { RecommendationsType } from '@/shared/types'
import { periodontalReportApi, reportApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: {
  reportId: Number,
  consultations: Array as PropType<string[]>,
  reCleaning: Number,
  isPlaqueReport: Boolean,
},
  emits: ['saved'],
  setup(__props, { emit }) {

const props = __props





const loading = ref(false)

const handleSavePeriodontalPageRecommendations = async (): Promise<void> => {
  loading.value = true

  const recommendationsData: RecommendationsType = {
    reportId: props.reportId,
    reCleaning: props.reCleaning,
  }

  const [error] = await periodontalReportApi.updateRecommendations(
    recommendationsData
  )

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Рекомендации сохранены',
      type: 'success',
    })

    emit('saved')
  }

  loading.value = false
}

const handleSavePlaqueReportRecommendations = async (): Promise<void> => {
  loading.value = true

  const recommendationsData: RecommendationsType = {
    reportId: props.reportId,
    consultation: props.consultations,
    reCleaning: props.reCleaning,
  }

  const [error] = await reportApi.updateRecommendations(recommendationsData)

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Рекомендации сохранены',
      type: 'success',
    })

    emit('saved')
  }

  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (__props.isPlaqueReport)
    ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        loading: loading.value,
        class: "save-recommendations",
        round: "",
        type: "primary",
        onClick: handleSavePlaqueReportRecommendations
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["loading"]))
    : (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        loading: loading.value,
        class: "save-recommendations",
        round: "",
        type: "primary",
        onClick: handleSavePeriodontalPageRecommendations
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["loading"]))
}
}

})